import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSettings = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "12",
  fill: "var(--mds-nav-icon-accent)",
  r: "3"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M13.172 1.5a1 1 0 0 1 .982.813l.18.95c.07.365.34.658.689.79a8.49 8.49 0 0 1 2.343 1.356c.29.235.677.322 1.03.2l.915-.32a1 1 0 0 1 1.195.445l1.173 2.03a1 1 0 0 1-.213 1.258l-.733.632c-.282.243-.4.622-.341.99a8.559 8.559 0 0 1 0 2.712c-.06.368.06.747.341.99l.733.632a1 1 0 0 1 .213 1.257l-1.173 2.031a1 1 0 0 1-1.195.444l-.916-.319a1.075 1.075 0 0 0-1.028.2 8.492 8.492 0 0 1-2.344 1.355 1.076 1.076 0 0 0-.688.792l-.181.95a1 1 0 0 1-.982.812h-2.345a1 1 0 0 1-.983-.813l-.18-.95a1.076 1.076 0 0 0-.688-.79A8.492 8.492 0 0 1 6.63 18.59a1.075 1.075 0 0 0-1.028-.2l-.915.319a1 1 0 0 1-1.195-.444L2.32 16.234a1 1 0 0 1 .212-1.257l.733-.632c.282-.244.4-.623.341-.99a8.56 8.56 0 0 1 0-2.71 1.076 1.076 0 0 0-.341-.99l-.733-.632a1 1 0 0 1-.212-1.257l1.172-2.03a1 1 0 0 1 1.195-.445l.915.319c.352.122.74.035 1.028-.2a8.491 8.491 0 0 1 2.346-1.357c.348-.132.618-.425.687-.79l.181-.95a1 1 0 0 1 .983-.813h2.345ZM11.999 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
})), "IcSettings");

export { IcSettings };
//# sourceMappingURL=ic-settings.js.map
